import { useEffect, useRef } from 'react';

const ACTIVITY = ['mousedown', 'keydown', 'touchstart', 'scroll', 'pointerdown'] as const;

/** Logs the user out after `minutes` of REAL user inactivity (not network/polling).
 *  Pass enabled=false to disable (remember-mode / Microsoft sessions). */
export function useIdleLogout(minutes: number, enabled: boolean, onIdle: () => void) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    if (!enabled || minutes <= 0) return;
    const reset = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(onIdle, minutes * 60_000);
    };
    ACTIVITY.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      if (timer.current) clearTimeout(timer.current);
      ACTIVITY.forEach(e => window.removeEventListener(e, reset));
    };
  }, [minutes, enabled, onIdle]);
}
